<div class="visionboard-editor">
    <h1>Visionboard</h1>
    <p class="breadcrumb">home/ descúbrete / herramientas / Visionboard</p>

    <div class="editor-container">
        <div class="editor-header">
            <input type="text" [(ngModel)]="visionboardName" class="visionboard-title" placeholder="Nombre de visionboard">
            
            <div class="editor-actions">
                <!-- <button class="share-button" disabled>Compartir</button> -->
                <button class="save-button" (click)="saveVisionboard()" [disabled]="isLoading || images.length < 3">
                    <span *ngIf="isLoading">Guardando...</span>
                    <span *ngIf="!isLoading">Guardar</span>
                </button>
                <div *ngIf="images.length < 3" class="validation-message">
                    Debes agregar al menos 3 imágenes para guardar.
                </div>
            </div>
        </div>

        <div class="editor-content">
            <div class="drop-area" *ngIf="images.length === 0">
                <div class="drop-content">
                    <h3>Arrastra o agrega fotos aquí</h3>
                    <p>Te recomendamos agregar entre 3 a 5 fotos para realizar tu Visionboard. Idealmente, combina imágenes cuadradas y rectangulares para una mejor composición visual.</p>
                    <button class="upload-button" (click)="uploadImages()" [disabled]="isLoading">Cargar fotos del ordenador</button>
                </div>
            </div>

            <div class="image-grid" cdkDropList [cdkDropListData]="images" (cdkDropListDropped)="drop($event)">
                <!-- Mostrar las imágenes cargadas -->
                <div class="image-item" *ngFor="let image of images; let i = index; trackBy: trackByImageId" cdkDrag>
                    
                    <img [src]="image.preview" alt="Visionboard image">
                    
                    <div class="image-actions">
                        <button class="remove-image" (click)="removeImage(i)">
                            <i class="fa-solid fa-times"></i>
                        </button>
                    </div>
                </div>
                
                <!-- Información sobre arrastre de imágenes -->
                <div class="drag-info" *ngIf="images.length > 1">
                    Puedes arrastrar las imágenes para ordenarlas como desees
                </div>
                
                <!-- Botón para agregar más imágenes (solo si hay menos de 5) -->
                <div class="add-more-button" (click)="uploadImages()" *ngIf="images.length < 5">
                    <i class="fa-solid fa-plus"></i>
                </div>
            </div>
        </div>


    </div>
</div> 